module.exports = __webpack_public_path__ + "img/20200512_163053.7b1ac8d0.jpg";